import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { DataTableHeader } from "vuetify";

import { VignetteHelpers, VignetteRoutes } from "@/types";
import { VignetteCommitteeStafferResponse } from "@/types/api/SwaggerOutput";
import { ParsedResponse } from "@/types/utils/CaseTypes";

interface Props {
  staffers: ParsedResponse<VignetteCommitteeStafferResponse[]>;
  hideFirstTitle?: boolean;
}

type CommitteeStaffer = ParsedResponse<VignetteCommitteeStafferResponse>;


export default /*#__PURE__*/_defineComponent({
  __name: 'StafferTable',
  props: {
    staffers: null,
    hideFirstTitle: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  staffers: ParsedResponse<VignetteCommitteeStafferResponse[]>;
  hideFirstTitle?: boolean;
};



// makes default for use of optional prop value is false
const hideFirstTitle = props.hideFirstTitle ?? false;

const staffers: CommitteeStaffer[] = props.staffers;

const search = ref("");
const headers: DataTableHeader[] = [
  {
    text: "Name",
    value: "firstName",
    sortable: true,
    filterable: true,
    align: "start",
  },
  {
    text: "Title",
    value: "title",
    sortable: true,
    filterable: true,
  },
];

const nameSearchFilter = (
  value: string,
  search: string,
  item: CommitteeStaffer
) => {
  if (!search) return true;
  search = search.toLowerCase();
  return (
    item.firstName.toLowerCase().includes(search) ||
    (item.lastName && item.lastName.toLowerCase().includes(search))
  );
};

return { __sfc: true,props, hideFirstTitle, staffers, search, headers, nameSearchFilter, VignetteHelpers, VignetteRoutes }
}

})